module.exports = __webpack_public_path__ + "static/media/linkedin-violet.d8664287.svg";